import { useRef } from 'react';

import type { CanvasRef } from '../../core/components/canvas/Canvas.js';
import { XYChartThresholdIndicators } from '../components/thresholds/XYChartThresholdIndicators.js';
import { useXYChartData } from '../hooks/useXYChartData.js';
import { XYChartGenericCanvasLayout } from './XYChartGenericCanvasLayout.js';
import { XYChartHighlightedCanvasLayout } from './XYChartHighlightedCanvasLayout.js';

export function XYChartLayout() {
  const canvasRef = useRef<CanvasRef[]>([]);
  const { filteredSeriesWithDatapoints } = useXYChartData();

  const handleOpacityChange = (value: string) => {
    if (canvasRef?.current) {
      // The opacity change is done through direct DOM manipulation since canvas elements are not React components and we want to avoid re-renders
      canvasRef.current.forEach((canvas) => {
        canvas.customSetStyle('opacity', value);
      });
    }
  };

  return (
    <>
      <XYChartGenericCanvasLayout
        seriesWithDatapoints={filteredSeriesWithDatapoints}
        ref={canvasRef}
      />
      <XYChartHighlightedCanvasLayout handleOpacity={handleOpacityChange} />
      <XYChartThresholdIndicators />
    </>
  );
}

XYChartLayout['displayName'] = 'XYChartLayout';
